export default __webpack_public_path__ + "static/media/advertise.f64f13c9.png";